import React from 'react';
import { useNavigate } from 'react-router-dom';
import MetricCard from './MetricCard';
import WorkflowPipeline from './WorkflowPipeline';
import ExceptionCenter from './ExceptionCenter';

export const ManagerCommandCenter = ({ stats, loading, activeCentreName }) => {
  const navigate = useNavigate();

  const phlebo = stats?.phlebotomy || {};
  const access = stats?.accession || {};
  const patho = stats?.pathology || {};
  const approv = stats?.approval || {};
  const settle = stats?.settlement || {};

  return (
    <div className="lis-command-deck manager-deck">
      {/* 1. Operational Management Telemetry */}
      <div className="lis-deck-section">
        <div className="lis-section-header-compact">
          <div className="lis-section-header-left">
            <span className="lis-section-kicker">OPERATIONS MANAGEMENT</span>
            <h3 className="lis-section-title">Throughput & Financial Overview</h3>
            <span className="lis-section-sub">&bull; {activeCentreName}</span>
          </div>
          <div className="lis-deck-actions">
            <button
              type="button"
              className="lis-deck-action-primary"
              onClick={() => navigate('/settlement')}
            >
              Receivables
            </button>
            <button
              type="button"
              className="lis-deck-quick-btn"
              onClick={() => navigate('/reports/approval-queue')}
            >
              Approval Queue
            </button>
          </div>
        </div>

        <div className="lis-kpi-grid">
          <MetricCard
            title="Total Registered Today"
            value={phlebo.totalPatientsToday ?? stats?.recentRegistrations?.totalCount ?? 0}
            subtitle="Patient throughput"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/registration"
            variant="info"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
              </svg>
            }
          />

          <MetricCard
            title="Phlebotomy Backlog"
            value={phlebo.pendingCount ?? 0}
            subtitle="Samples awaiting draw"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/phlebotomy"
            variant={phlebo.pendingCount > 0 ? 'warning' : 'success'}
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            }
          />

          <MetricCard
            title="Testing Worklist Pending"
            value={patho.pendingCount ?? 0}
            subtitle="In bench processing"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/pathology-results"
            variant={patho.pendingCount > 0 ? 'warning' : 'success'}
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            }
          />

          <MetricCard
            title="Awaiting Doctor Release"
            value={approv.totalPending ?? 0}
            subtitle="Reports awaiting sign-off"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/reports/approval-queue"
            variant={approv.totalPending > 0 ? 'warning' : 'success'}
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            }
          />

          <MetricCard
            title="Released Reports Today"
            value={approv.totalApprovedToday ?? 0}
            subtitle="Completed diagnostic cases"
            status={loading ? 'LOADING' : 'LIVE'}
            route="/reports/approval-queue"
            variant="success"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            }
          />

          <MetricCard
            title="Total Receivables Outstanding"
            value={`₹${Number(settle.totalDueAmount || 0).toLocaleString('en-IN')}`}
            subtitle={`${settle.unpaidCount || 0} unpaid patient bills`}
            status={loading ? 'LOADING' : 'LIVE'}
            route="/settlement"
            variant="purple"
            icon={
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            }
          />
        </div>
      </div>

      {/* 2. Visual Workflow Pipeline */}
      <WorkflowPipeline stats={stats} loading={loading} />

      {/* 3. Operational Exception Triaging */}
      <ExceptionCenter stats={stats} loading={loading} />
    </div>
  );
};

export default ManagerCommandCenter;
